// @flow

const sheetId = '1tUzbTZwahETh1g6OtmEvHWe2AkGEs7GA3PFWqOTdWhM';
export const getSheetsUrl = (token: string) => {
  return `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}?access_token=${token}`;
};
export const getValuesUrl = (range: string, token: string) => {
  return `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${range}?access_token=${token}`;
};
export const getBatchValuesUrl = (ranges: string[], token: string) => {
  let rangeQueries = '';
  ranges.forEach(range => (rangeQueries += '&ranges=' + range));
  return `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values:batchGet?access_token=${token}${rangeQueries}`;
};

export const fetchJson = async url => {
  const res = await fetch(url);
  if (!res.ok) {
    if (res.status === 403) {
      throw new Error('This account is not authorized.');
    }
    throw new Error(`Fetching failed: ${res.statusText}`);
  }
  return await res.json();
};



// WEBPACK FOOTER //
// ./utils/sheetsUtils.js